<ion-content [fullscreen]="true" [scrollY]="true" #content>
    <app-website-component class="full-screen-width" [pageMode]="true" [accountId]="accountId" [linkId]="linkId" [guestId]="guestId" [groupId]="groupId" [setWebsiteType]="websiteType" [setReady]="ready"></app-website-component>
</ion-content>
<!--  -->